import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Finish} from '../index';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';

class ProposalSendSucess extends Component {
  componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.ProposalSendSucess.title,
    );
  }

  render() {
    return <Finish estadoEspecial={true} />;
  }
}

const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, {})(ProposalSendSucess);
